module.exports = __webpack_public_path__ + "img/expenses-type-add-update.e421525c.svg";